
import { Grid } from '@mui/material';
import { useEffect, useMemo } from 'react';
import Dialog, { IDefaultDialogProps } from '../../Dialog';
import { ActionButton } from '../../Button';
import { useLanguageContext } from '../../../contexts/LanguageContext';
import DefaultConstants from '../../../data/Constants';
import useState from '../../../hooks/useState';
import IServiceOrder from '../../../interfaces/IServiceOrder';
import DateField from '../../DateField';


interface IUpdateEstimatedCompletionDateDialogProps extends IDefaultDialogProps {
    serviceOrder: IServiceOrder;
    handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
}

interface IStateValues {
    estimatedCompletionDate: Date | undefined;
}

const UpdateEstimatedCompletionDateDialog: React.FC<IUpdateEstimatedCompletionDateDialogProps> = ({
    open,
    handleClose,
    serviceOrder,
    handleSubmit
}) => {
    const { translate } = useLanguageContext();

    const state = useState<IStateValues>({
        estimatedCompletionDate: undefined
    });


    useEffect(() => {
        if (open) {
            state.update('estimatedCompletionDate', serviceOrder.estimatedCompletionDate);
        }
        // eslint-disable-next-line
    }, [open]);
    

    const dialogActions = useMemo(() => {
        return [
            <ActionButton action='cancel' onClick={handleClose} />,
            <ActionButton action='save' type='submit' />
        ];
        // eslint-disable-next-line
    }, [translate]);

    
    return (
        <Dialog
            open={open}
            handleClose={handleClose}
            title={translate('editEstimatedCompletionDate')}
            dialogActions={dialogActions}
            onSubmit={handleSubmit}
            className='dialogactions-spacebetween overflow-inherit'
            absolute={true}
            dividers={true}
        >
            <Grid container rowSpacing={DefaultConstants.gridRowSpacing}>
                <Grid item xs={12}>
                    <DateField
                        label={translate('estimatedCompletionDate')}
                        format='DD/MM/YYYY'
                        name='estimatedCompletionDate'
                        value={state.values.estimatedCompletionDate}
                        onChange={value => state.update('estimatedCompletionDate', value)}
                        disablePast={true}
                        required={false}
                    />
                </Grid>
            </Grid>
        </Dialog>
    );
}

export default UpdateEstimatedCompletionDateDialog;